import "./gplans.scss";

import { configureRouter } from "./gplans-router.js";
import { vendorModule } from "./vendor/gplans-vendor.module";
import { coreModule } from "./core/core.module";
import { sharedModule } from "./shared/shared.module";
import { uiModule } from "./ui/ui.module";
import { gplansConfigModule } from "./gplans.config";
import { authModule } from "./auth/auth.module";
//import { storeModule } from "./store/store.module";
import { GplansAppComponent } from "./app.component";

import { onGplansRun } from "./gplans.run";
// import { intercomModule } from "./intercom/intercom.module";



var gplansSurveyControllers = angular.module('gplans.survey.controllers', []);
var gplansDashboard = angular.module('gplans.dashboard', []);
var gplansSurveyServices = angular.module('gplans.survey.services', []);
var gplansLayoutControllers = angular.module('gplans.layout.controllers', []);
var gplansDirectives = angular.module('gplans.directives', []);
var gplansLayoutServices = angular.module('gplans.layout.services', []);
var gplansUtils = angular.module('gplans.utils', ['gplans.utils.services']);
//const gplansStore =  angular.module('gplans.store',[]);

angular.module('gplans.utils.services', []);
angular.module('gplans.authentication', ['gplans.authentication.controllers']);
angular.module('gplans.authentication.controllers', []);
angular.module('gplans.dashboard', [
'gplans.dashboard.directives',
'gplans.dashboard.controllers',
'gplans.dashboard.services']);

angular.module('gplans.dashboard.directives', []);
angular.module('gplans.dashboard.controllers', []);
angular.module('gplans.dashboard.services', []);
angular.module('gplans.store', [
'gplans.store.components',
'gplans.store.controllers']);

angular.module('gplans.tips', [
'gplans.tips.controllers']);

angular.module('gplans.store.components', []);
angular.module('gplans.store.controllers', []);
angular.module('gplans.tips.controllers', []);

require('../app/gplans.mixpanel.module');
//require('../app/gplans.siftscience.module');

var gplansModule = angular.module('gplans', [
'ngSanitize',
vendorModule.name,
sharedModule.name,
coreModule.name,
uiModule.name,
gplansConfigModule.name,
authModule.name,
//storeModule.name,
// intercomModule.name,
'gplans.mixpanel',
//'gplans.siftscience',
gplansSurveyControllers.name,
gplansDashboard.name,
gplansSurveyServices.name,
gplansLayoutControllers.name,
gplansDirectives.name,
gplansLayoutServices.name,
gplansUtils.name,
//gplansStore.name,
'gplans.store',
'gplans.authentication',
'gplans.utils',
'gplans.tips']).

component('gplansApp', GplansAppComponent).
config(configureRouter).
run(onGplansRun).
filter('capitalize', function () {
  return function (input) {
    return !!input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
});


var intercomContext = require.context("../app/intercom/", true, /\.(module|component|controller|directive|service)\.js$/);
intercomContext.keys().forEach(function (key) {
  intercomContext(key);
});

var surveyContext = require.context("../app/survey/", true, /\.(component|controller|directive|service)\.js$/);
surveyContext.keys().forEach(function (key) {
  surveyContext(key);
});

var layoutContext = require.context("../app/layout/", true, /\.(component|controller|directive|service)\.js$/);
layoutContext.keys().forEach(function (key) {
  layoutContext(key);
});

var authenticationContext = require.context("../app/authentication/", true, /\.(controller)\.js$/);
authenticationContext.keys().forEach(function (key) {
  authenticationContext(key);
});

var utilsContext = require.context("../app/utils/", true, /\.(component|controller|directive|service)\.js$/);
utilsContext.keys().forEach(function (key) {
  utilsContext(key);
});

var dashboardContext = require.context("../app/dashboard/", true, /\.(directive|service)\.js$/);
dashboardContext.keys().forEach(function (key) {
  dashboardContext(key);
});

var storeContext = require.context("../app/store/", true, /\.(component|controller)\.js$/);
storeContext.keys().forEach(function (key) {
  storeContext(key);
});

var tipsContext = require.context("../app/tips/", true, /\.(controller)\.js$/);
tipsContext.keys().forEach(function (key) {
  tipsContext(key);
});

export function bootstrapGplansApp() {
  angular.bootstrap(document.body, [gplansModule.name], {
    strictDi: true });

}